import { render, staticRenderFns } from "./MetricsRating.vue?vue&type=template&id=d0fc00e2"
import script from "./MetricsRating.vue?vue&type=script&lang=js"
export * from "./MetricsRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports